export var getAllAccounts = function (domain) { var _a; return (_a = domain === null || domain === void 0 ? void 0 : domain.data) !== null && _a !== void 0 ? _a : null; };
//# sourceMappingURL=selectors.js.map